const config = {
	wechat: {
		oauth: function() {
			const website_url = encodeURIComponent(window.location.href); // 需要回跳的链接
			return `https://evonik-ev-3d.blue-dot.com.cn/api-dev/platform/wechat/auth?website_url=${website_url}`;
		}
	}
};

export default config;
